(function () {
  'use strict';
  if (window.__chagualPlanterDescription) return;
  window.__chagualPlanterDescription = true;

  function autorregante(variant) {
    return Array.isArray(variant.options) && variant.options.some(function (option) {
      return String(option).trim().toLowerCase() === 'autorregante';
    });
  }

  function init(root) {
    if (root.dataset.descriptionReady) return;
    var section = root.closest('.js-product-section');
    var select = section && section.querySelector('select[name="id"][data-variants]');
    var payload = root.querySelector('[data-planter-description-variants]');
    if (!select || !payload) return;
    var variants;
    try { variants = JSON.parse(payload.textContent); } catch (_error) { return; }
    // Only mixed products with an explicit option can be filtered. A product
    // name, SKU or shared description never establishes a variant's equipment.
    if (!Array.isArray(variants) || !variants.some(autorregante)) return;
    var marker = 'Recomendaciones de uso del sistema autorregante';
    var walker = document.createTreeWalker(root, 4);
    var start = null, offset = -1;
    while (walker.nextNode()) {
      if (payload.contains(walker.currentNode)) continue;
      offset = walker.currentNode.textContent.indexOf(marker);
      if (offset !== -1) { start = walker.currentNode; break; }
    }
    if (!start) return;
    // The legacy metafield stores the recommendations as a trailing section,
    // often inside one paragraph with <br>s. A Range preserves balanced markup.
    var range = document.createRange();
    range.setStart(start, offset);
    range.setEnd(root, root.childNodes.length);
    var advice = document.createElement('div');
    advice.setAttribute('data-self-watering-advice', '');
    advice.hidden = true;
    advice.appendChild(range.extractContents());
    root.appendChild(advice);
    root.dataset.descriptionReady = 'true';

    function sync() {
      var selected = variants.filter(function (variant) { return String(variant.id) === String(select.value); });
      advice.hidden = selected.length !== 1 || !autorregante(selected[0]);
    }
    var frame = null;
    function schedule(event) {
      if (!event.target.matches('select[name="id"][data-variants], .swatch_options input[type="radio"]')) return;
      advice.hidden = true;
      if (frame !== null) window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(function () {
        frame = window.requestAnimationFrame(function () { frame = null; sync(); });
      });
    }
    section.addEventListener('change', schedule);
    function unload(event) {
      if (event.target !== section && !event.target.contains(section)) return;
      section.removeEventListener('change', schedule);
      if (frame !== null) window.cancelAnimationFrame(frame);
      document.removeEventListener('shopify:section:unload', unload);
    }
    document.addEventListener('shopify:section:unload', unload);
    sync();
  }
  function boot(scope) { scope.querySelectorAll('[data-planter-description]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
  else boot(document);
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
}());
